/**
 * Chat History Utility
 * Manages local storage for MCP chat history
 */

const STORAGE_KEY = 'mcp_chat_history';
const MAX_HISTORY_DAYS = 7;

interface StoredHistory {
  messages: any[];
  lastUpdated: string;
}

/**
 * Save chat history to localStorage
 */
export const saveChatHistory = (messages: any[]): void => {
  try {
    const data: StoredHistory = {
      messages,
      lastUpdated: new Date().toISOString(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.error('Failed to save chat history:', error);
  }
};

/**
 * Load chat history from localStorage
 * Returns empty array if history is older than MAX_HISTORY_DAYS
 */
export const loadChatHistory = (): any[] => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return [];

    const data: StoredHistory = JSON.parse(stored);

    // Check if history is older than MAX_HISTORY_DAYS
    const lastUpdated = new Date(data.lastUpdated);
    const daysSince =
      (Date.now() - lastUpdated.getTime()) / (1000 * 60 * 60 * 24);

    if (daysSince > MAX_HISTORY_DAYS) {
      clearChatHistory();
      return [];
    }

    return data.messages || [];
  } catch (error) {
    console.error('Failed to load chat history:', error);
    return [];
  }
};

/**
 * Clear chat history from localStorage
 */
export const clearChatHistory = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Failed to clear chat history:', error);
  }
};
